import { Button } from 'components/button';
import { useEffect, useState } from 'react';
import { ticketsService } from 'views/services/ticketsService';
import { useAdminsStore } from 'views/store/useAdminsStore';
import { useTicketsStore } from 'views/store/useTicketsStore';
import { ReadPermissionGate } from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';
import { usePermissions } from 'hooks/usePermissions';

export const SearchTabs = () => {
  const [id, setId] = useState('');
  const [isLoading, setLoading] = useState(false);
  const { getBy, setGetBy } = useTicketsStore();
  const { admins } = useAdminsStore();
  const { canUpdate } = usePermissions();

  const handleFindByTicketId = async () => {
    setLoading(true);
    if (getBy === 'byTicketId') {
      await ticketsService.getTicketById(id);
    } else if (getBy === 'byUserId') {
      await ticketsService.getTicketByUserId(id);
    } else if (getBy === 'byAdminId') {
      await ticketsService.getTicketByAdminId(id);
    }
    setLoading(false);
  };

  useEffect(() => {
    setId('');
  }, [getBy]);

  return (
    <>
      <div className="flex gap-4 mt-8">
        <ReadPermissionGate
          resource={PERMISSION_RESOURCES.FILTER_BY_ASSIGNED_ADMIN}
        >
          <Button
            variant={getBy === 'byAdminId' ? 'primary' : 'secondary'}
            onClick={() => setGetBy('byAdminId')}
            disabled={
              !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
              !canUpdate(PERMISSION_RESOURCES.FILTER_BY_ASSIGNED_ADMIN)
            }
          >
            By assigned admin
          </Button>
        </ReadPermissionGate>
        <ReadPermissionGate resource={PERMISSION_RESOURCES.GET_ALL_TICKETS}>
          <Button
            variant={getBy === 'all' ? 'primary' : 'secondary'}
            onClick={() => setGetBy('all')}
            disabled={
              !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
              !canUpdate(PERMISSION_RESOURCES.GET_ALL_TICKETS)
            }
          >
            Get All Tickets
          </Button>
        </ReadPermissionGate>
        <ReadPermissionGate resource={PERMISSION_RESOURCES.GET_BY_TICKET_ID}>
          <Button
            variant={getBy === 'byTicketId' ? 'primary' : 'secondary'}
            onClick={() => setGetBy('byTicketId')}
            disabled={
              !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
              !canUpdate(PERMISSION_RESOURCES.GET_BY_TICKET_ID)
            }
          >
            Get by Ticket ID
          </Button>
        </ReadPermissionGate>
        <ReadPermissionGate
          resource={PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID}
        >
          <Button
            variant={getBy === 'byUserId' ? 'primary' : 'secondary'}
            onClick={() => setGetBy('byUserId')}
            disabled={
              !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
              !canUpdate(PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID)
            }
          >
            Get all by Client ID
          </Button>
        </ReadPermissionGate>
      </div>

      {['byTicketId', 'byUserId'].includes(getBy) && (
        <div className="mt-6">
          <div className="flex items-center gap-4">
            <input
              type="text"
              value={id}
              onChange={e => setId(e.target.value)}
              placeholder={
                getBy === 'byTicketId' ? 'Enter Ticket ID' : 'Enter Client ID'
              }
              disabled={
                getBy === 'byTicketId'
                  ? !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
                    !canUpdate(PERMISSION_RESOURCES.GET_BY_TICKET_ID)
                  : !canUpdate(PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID)
              }
              className="dark:bg-gray-800 dark:text-white border p-2 rounded w-64 disabled:opacity-50 disabled:cursor-not-allowed"
            />
            <ReadPermissionGate
              resource={
                getBy === 'byTicketId'
                  ? PERMISSION_RESOURCES.GET_BY_TICKET_ID
                  : PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID
              }
            >
              <Button
                onClick={handleFindByTicketId}
                disabled={
                  !id ||
                  isLoading ||
                  (getBy === 'byTicketId'
                    ? !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
                      !canUpdate(PERMISSION_RESOURCES.GET_BY_TICKET_ID)
                    : !canUpdate(PERMISSION_RESOURCES.GET_ALL_BY_CLIENT_ID))
                }
                variant={id ? 'primary' : 'secondary'}
              >
                Find
              </Button>
            </ReadPermissionGate>
          </div>
        </div>
      )}

      {getBy === 'byAdminId' && (
        <div className="mt-6">
          <div className="flex items-center gap-4">
            <select
              value={id}
              onChange={e => setId(e.target.value)}
              disabled={
                !canUpdate(PERMISSION_RESOURCES.SUPPORT_TICKETS) ||
                !canUpdate(PERMISSION_RESOURCES.FILTER_BY_ASSIGNED_ADMIN)
              }
              className="w-64 px-4 py-2 rounded-2xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <option value="" className="text-gray-500">
                Select Admin
              </option>
              {admins.map(admin => (
                <option key={admin.id} value={admin.id}>
                  {admin.name ?? admin.login}
                </option>
              ))}
            </select>

            <Button
              onClick={handleFindByTicketId}
              disabled={!id || isLoading}
              variant={id ? 'primary' : 'secondary'}
            >
              Find
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
